/**
 * this function opens the specified modal window
 * @param modalId
 */
export function openModal(modalId: string) {
  if (!!document.querySelector(`[modal-id="${modalId}"]`)) {
    const openModalElement: HTMLElement = document.querySelector(`[modal-id="${modalId}"]`) as HTMLElement;
    openModalElement.setAttribute("visible", "true");
  }
}
